import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { Anchor } from '../Anchor/Anchor'
import { Drawer } from '../Drawer/Drawer'
import { PoweredByToast } from '../PoweredByToast/PoweredByToast'
import { GiftCardLinks } from './GiftCardLinks/GiftCardLinks'
import { NavigationDrawerHeader } from './NavigationDrawerHeader/NavigationDrawerHeader'
import styles from './NavigationDrawer.module.css'
import { Link } from 'react-router-dom'
import { t } from '@local/translations'
import { useRestaurant } from '@local/do-secundo-restaurant-provider'

export const NavigationDrawer = ({ onClose }) => {
  const { isIntlRx } = useRestaurant()

  return (
    <Drawer
      header={<NavigationDrawerHeader onClose={onClose} />}
      onClose={onClose}
      footer={<PoweredByToast className={styles.poweredBy} />}
    >
      <ul className={styles.list}>
        <li>
          <Link
            className={cx(styles.listItem, 'type-default')}
            to={'/'}
            onClick={onClose}
          >
            {t('navigation-drawer.home')}
          </Link>
        </li>
        <GiftCardLinks />
        <li>
          <Anchor
            data-testid='nav-drawer-link-privacy'
            className={cx(styles.listItem, 'type-default')}
            href='https://pos.toasttab.com/privacy'
            target='_blank'
          >
            {t('navigation-drawer.privacy-statement')}
          </Anchor>
        </li>
        <li>
          <Anchor
            data-testid='nav-drawer-link-terms'
            className={cx(styles.listItem, 'type-default')}
            href='https://pos.toasttab.com/terms-of-service/#diner-tos'
            target='_blank'
          >
            {t('navigation-drawer.terms-of-service')}
          </Anchor>
        </li>
        {isIntlRx && (
          <li>
            <button
              className={cx('type-default', styles.listItem)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()

                // Close drawer so that it doesn't interfere with the cookie settings modal
                onClose(e)

                requestAnimationFrame(() => {
                  window.OneTrust?.ToggleInfoDisplay()
                })
              }}
            >
              {t('navigation-drawer.cookie-settings')}
            </button>
          </li>
        )}
      </ul>
    </Drawer>
  )
}

NavigationDrawer.propTypes = {
  onClose: PropTypes.func.isRequired
}
